/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {SupplierBaseContract} from '../../api/contracts/supplier/supplier-base.contract';

export function suppliersPipe(cellValue: SupplierBaseContract): string {
    let displayValue = '-';

    if (cellValue?.name != null && cellValue?.code != null) {
        displayValue = `${cellValue.code} - ${cellValue.name}`;
    }

    return displayValue;
}
